import type { Trigger, PopupInstance, TriggerConfig } from '../types';

export class HashTrigger implements Trigger {
	private handler: (() => void) | null = null;

	init(popup: PopupInstance, config: TriggerConfig): void {
		const hashValue = config.hashValue;
		if (!hashValue) return;

		const target = hashValue.startsWith('#') ? hashValue : '#' + hashValue;

		this.handler = () => {
			if (window.location.hash === target) {
				popup.show();
			}
		};

		window.addEventListener('hashchange', this.handler);

		// Check on init in case the hash is already set
		if (window.location.hash === target) {
			popup.show();
		}
	}

	destroy(): void {
		if (this.handler) {
			window.removeEventListener('hashchange', this.handler);
			this.handler = null;
		}
	}
}
